import type { PointImpossibleTitleValue } from '../types/points';

export function getImpossibleTitleLabel(
  titleValue: string | null | undefined,
  titles?: PointImpossibleTitleValue[],
): string | null {
  if (!titleValue) {
    return null;
  }

  const match = titles?.find((item) => item.value === titleValue);
  return match?.label ?? titleValue;
}
